import type { AdPlacement, AdProvider } from './types'
import { adsenseBanner } from './providers/adsense'

// Order = waterfall priority. First provider gets the request today;
// future no-fill detection will walk to the next.
const REGISTRY: Record<AdPlacement, AdProvider[]> = {
  banner: [adsenseBanner],
}

export function getProviders(p: AdPlacement): AdProvider[] { return REGISTRY[p] }
export function getActiveProvider(p: AdPlacement): AdProvider | null {
  return REGISTRY[p][0] ?? null
}
